export const NOTIFICATIONS_REQUEST = "NOTIFICATIONS_REQUEST"
export const NOTIFICATIONS_SUCCESS = "NOTIFICATIONS_SUCCESS"
export const NOTIFICATIONS_ERROR = "NOTIFICATIONS_ERROR"